module.exports = __webpack_public_path__ + "components/app-store/static/mfc-featured-9ba67f956172c063ff2b8ea15d886d0b.jpg";